import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default function Ring({ color, size, text, className, style }) {
  const circles = [...Array(4)].map((_, index) => {
    return (
      <div
        className=""
        key={index}
        style={{
          borderColor: `${color} transparent transparent transparent`,
          width: size * 1,
          height: size * 1,
          margin: size * 0.1,
          borderWidth: size * 0.1,
        }}
      ></div>
    );
  });

  return (
    // <div
    // className=""

    //   className={classNames("lds-ring", className)}
    //   style={{ width: size, height: size, ...style }}
    // >

    //   {circles}
    // </div>
    <button
      type="button"
      className="inline-flex items-center px-2 py-1 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-500 hover:bg-green-500 focus:border-green-500 active:bg-green-500 transition ease-in-out duration-150 cursor-not-allowed"
      disabled
    >
      <svg
        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx={12}
          cy={12}
          r={10}
          stroke="currentColor"
          strokeWidth={4}
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      {text && <div className=" mr-1">{text}</div>}
      Processing
    </button>
  );
}

Ring.propTypes = {
  /** hex color */
  color: PropTypes.string,
  /** size in pixel */
  size: PropTypes.number,
  /** class name  */
  className: PropTypes.string,
  /** style object */
  style: PropTypes.object,
};

Ring.defaultProps = {
  color: "#fff",
  size: 35,
  className: "",
  style: {},
};
